export default __webpack_public_path__ + "static/media/launched.b58a9096.png";